import parse from 'html-react-parser'
import domPurify from 'dompurify'

import { SuccessIcon } from '@icons'

import { tr } from 'mmfintech-commons'

import './previewMessage.scss'

interface PreviewMessageProps {
  result: string
}

export const PreviewMessage = ({ result }: PreviewMessageProps) => {
  const message = result.replace(/\r?\n/g, '<br/>').replace(/\\n/g, '<br/>')

  return (
    <div className='preview-message-wrapper'>
      <SuccessIcon />
      <div>
        <div className='title'>{tr('FRONTEND.DEPOSIT.RESULT.SUCCESS', 'Success')}</div>
        {parse(domPurify.sanitize(message))}
      </div>
    </div>
  )
}
